import { useState } from "react";
import RichTextEditor from "react-rte";
import "./rte.css";

const PreviewTextArea = ({ id = "RTE", defaultValue, label }) => {
  const [content, setContent] = useState({
    value: RichTextEditor.createValueFromString(defaultValue, "html"),
  });

  return (
    <>
      <label htmlFor={id} style={{ marginBottom: 10, display: "block" }}>
        {label}
      </label>
      <RichTextEditor
        id={id}
        className="fontClass"
        value={content.value}
        onChange={() => setContent({ ...content })}
        readOnly={false}
      />
    </>
  );
};
export default PreviewTextArea;
